import { render, staticRenderFns } from "./ServiceModalRow.vue?vue&type=template&id=035bc008&scoped=true&"
import script from "./ServiceModalRow.vue?vue&type=script&lang=js&"
export * from "./ServiceModalRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceModalRow.vue?vue&type=style&index=0&id=035bc008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bc008",
  null
  
)

export default component.exports